import { LandingContent } from "./types";
import { fieldCoachLanding } from "./fieldCoach";
import { revenueAscentLanding } from "./revenueAscent";
import { serviceFeeAcademyLanding } from "./serviceFeeAcademy";
import { leadGenerationLanding } from "./leadGeneration";
import { reputationManagementLanding } from "./reputationManagement";
import { websiteSeoLanding } from "./websiteSeo";
import { serviceLineLanding } from "./serviceLine";
import { lionsPrideLanding } from "./lionsPride";
import { annualSummitLanding } from "./annualSummit";
import { partnerNetworkLanding } from "./partnerNetwork";

export * from "./types";

/** Landing content registry, keyed by catalog product slug. */
export const landingContentBySlug: Record<string, LandingContent> = {
  "field-coach": fieldCoachLanding,
  "revenue-ascent": revenueAscentLanding,
  "service-fee-academy": serviceFeeAcademyLanding,
  "lead-generation": leadGenerationLanding,
  "reputation-management": reputationManagementLanding,
  "website-seo": websiteSeoLanding,
  "service-line": serviceLineLanding,
  "lions-pride": lionsPrideLanding,
  "annual-summit": annualSummitLanding,
  "partner-network": partnerNetworkLanding,
};
